export const locales = [
  "en",
  "vi",
  "hi",
  "ur",
  "th",
  "bn",
  "id",
  "fil",
  "es-419",
  "pt-BR",
  "ja",
  "ko",
  "ru",
  "tr",
  "uk",
] as const;

export type Locale = (typeof locales)[number];

export type HomepageSEOContent = {
  title: string;
  description: string;
  noscriptTitle: string;
  noscriptBody: string;
  proofTitle: string;
  proofBody: string;
  planTitle: string;
  planBody: string;
  riskTitle: string;
  riskBody: string;
  learnLabel: string;
  pricingLabel: string;
};

export const seoLocaleContent: Record<Locale, HomepageSEOContent> = {
  en: {
    title: "Free Backtesting Tool for Crypto, Forex & Gold | Backtest",
    description:
      "Backtest crypto, forex and XAUUSD gold strategies online. Start free, set trading costs, and review drawdown, profit factor and every entry and exit.",
    noscriptTitle: "Backtest crypto, forex and gold strategies online",
    noscriptBody:
      "Test a rule on historical candles, inspect entries and exits, then save a baseline and change one condition to compare.",
    proofTitle: "See the chart, trades, and risk in one place.",
    proofBody:
      "Test a rule on historical candles, inspect entries and exits, then save a baseline and change one condition to compare.",
    planTitle: "Plan value",
    planBody:
      "Paid plans offer longer test ranges, more saved history, and more paper signal bots.",
    riskTitle: "You can lose capital",
    riskBody:
      "Trading crypto and financial assets is high risk. You may lose part or all of your capital.",
    learnLabel: "Read Learning Center",
    pricingLabel: "Pricing",
  },
  vi: {
    title: "Backtest - Kiểm thử chiến lược giao dịch",
    description:
      "Kiểm thử quy tắc trên nến lịch sử, xem điểm vào và thoát, rồi lưu kết quả gốc và đổi một điều kiện để so sánh.",
    noscriptTitle: "Backtest - Kiểm thử chiến lược giao dịch",
    noscriptBody:
      "Kiểm thử quy tắc trên nến lịch sử, xem điểm vào và thoát, rồi lưu kết quả gốc và đổi một điều kiện để so sánh.",
    proofTitle: "Xem biểu đồ, giao dịch và rủi ro tại một nơi.",
    proofBody:
      "Kiểm thử quy tắc trên nến lịch sử, xem điểm vào và thoát, rồi lưu kết quả gốc và đổi một điều kiện để so sánh.",
    planTitle: "Giá trị gói",
    planBody:
      "Gói trả phí mở khoảng kiểm thử dài hơn, nhiều lịch sử đã lưu và bot tín hiệu mô phỏng hơn.",
    riskTitle: "Có thể mất vốn",
    riskBody:
      "Giao dịch crypto và tài sản tài chính có rủi ro cao. Bạn có thể mất một phần hoặc toàn bộ số vốn.",
    learnLabel: "Đọc trung tâm kiến thức",
    pricingLabel: "Bảng giá",
  },
  hi: {
    title: "Backtest - ट्रेडिंग रणनीति टेस्ट करें",
    description:
      "ऐतिहासिक कैंडल पर नियम जाँचें, प्रवेश और निकास देखें, फिर मूल परिणाम सहेजकर तुलना के लिए एक शर्त बदलें।",
    noscriptTitle: "Backtest - ट्रेडिंग रणनीति टेस्ट करें",
    noscriptBody:
      "ऐतिहासिक कैंडल पर नियम जाँचें, प्रवेश और निकास देखें, फिर मूल परिणाम सहेजकर तुलना के लिए एक शर्त बदलें।",
    proofTitle: "चार्ट, ट्रेड और जोखिम एक जगह देखें।",
    proofBody:
      "ऐतिहासिक कैंडल पर नियम जाँचें, प्रवेश और निकास देखें, फिर मूल परिणाम सहेजकर तुलना के लिए एक शर्त बदलें।",
    planTitle: "योजना का मूल्य",
    planBody:
      "सशुल्क प्लान लंबी टेस्ट अवधि, अधिक सहेजा हुआ इतिहास और अधिक पेपर सिग्नल बॉट देते हैं।",
    riskTitle: "पूंजी का नुकसान हो सकता है",
    riskBody:
      "क्रिप्टो और वित्तीय संपत्तियों में ट्रेडिंग उच्च जोखिम वाली है। आप अपनी कुछ या पूरी पूंजी खो सकते हैं।",
    learnLabel: "सीखने का केंद्र पढ़ें",
    pricingLabel: "मूल्य",
  },
  ur: {
    title: "Backtest - ٹریڈنگ حکمت عملی ٹیسٹر",
    description:
      "تاریخی کینڈلز پر قواعد آزمائیں، داخلہ اور اخراج دیکھیں، پھر اصل نتیجہ محفوظ کرکے موازنے کے لیے ایک شرط بدلیں۔",
    noscriptTitle: "Backtest - ٹریڈنگ حکمت عملی ٹیسٹر",
    noscriptBody:
      "تاریخی کینڈلز پر قواعد آزمائیں، داخلہ اور اخراج دیکھیں، پھر اصل نتیجہ محفوظ کرکے موازنے کے لیے ایک شرط بدلیں۔",
    proofTitle: "چارٹ، سودے اور خطرہ ایک جگہ دیکھیں۔",
    proofBody:
      "تاریخی کینڈلز پر قواعد آزمائیں، داخلہ اور اخراج دیکھیں، پھر اصل نتیجہ محفوظ کرکے موازنے کے لیے ایک شرط بدلیں۔",
    planTitle: "پلان کی قدر",
    planBody:
      "بامعاوضہ پلان زیادہ طویل ٹیسٹ، زیادہ محفوظ ہسٹری اور زیادہ پیپر سگنل بوٹس دیتے ہیں۔",
    riskTitle: "سرمایہ ضائع ہو سکتا ہے",
    riskBody:
      "کرپٹو اور مالی اثاثوں کی ٹریڈنگ میں زیادہ خطرہ ہے۔ آپ اپنا کچھ یا پورا سرمایہ کھو سکتے ہیں۔",
    learnLabel: "لرننگ سینٹر پڑھیں",
    pricingLabel: "قیمتیں",
  },
  th: {
    title: "Backtest - ทดสอบกลยุทธ์เทรด",
    description:
      "ทดสอบกฎกับแท่งราคาในอดีต ตรวจจุดเข้าและออก แล้วบันทึกผลตั้งต้นและเปลี่ยนหนึ่งเงื่อนไขเพื่อเปรียบเทียบ",
    noscriptTitle: "Backtest - ทดสอบกลยุทธ์เทรด",
    noscriptBody:
      "ทดสอบกฎกับแท่งราคาในอดีต ตรวจจุดเข้าและออก แล้วบันทึกผลตั้งต้นและเปลี่ยนหนึ่งเงื่อนไขเพื่อเปรียบเทียบ",
    proofTitle: "ดูกราฟ การเทรด และความเสี่ยงในที่เดียว",
    proofBody:
      "ทดสอบกฎกับแท่งราคาในอดีต ตรวจจุดเข้าและออก แล้วบันทึกผลตั้งต้นและเปลี่ยนหนึ่งเงื่อนไขเพื่อเปรียบเทียบ",
    planTitle: "คุณค่าของแพ็กเกจ",
    planBody:
      "แพ็กเกจแบบชำระเงินให้ช่วงทดสอบยาวขึ้น ประวัติที่บันทึกมากขึ้น และบอตสัญญาณจำลองมากขึ้น",
    riskTitle: "อาจสูญเสียเงินทุน",
    riskBody:
      "การเทรดคริปโตและสินทรัพย์ทางการเงินมีความเสี่ยงสูง คุณอาจสูญเสียเงินบางส่วนหรือทั้งหมด",
    learnLabel: "อ่านศูนย์การเรียนรู้",
    pricingLabel: "ราคา",
  },
  bn: {
    title: "Backtest - ট্রেডিং স্ট্র্যাটেজি টেস্টার",
    description:
      "ঐতিহাসিক ক্যান্ডলে নিয়ম পরীক্ষা করুন, প্রবেশ ও প্রস্থান দেখুন, তারপর মূল ফল সংরক্ষণ করে তুলনার জন্য একটি শর্ত বদলান।",
    noscriptTitle: "Backtest - ট্রেডিং স্ট্র্যাটেজি টেস্টার",
    noscriptBody:
      "ঐতিহাসিক ক্যান্ডলে নিয়ম পরীক্ষা করুন, প্রবেশ ও প্রস্থান দেখুন, তারপর মূল ফল সংরক্ষণ করে তুলনার জন্য একটি শর্ত বদলান।",
    proofTitle: "চার্ট, ট্রেড ও ঝুঁকি এক জায়গায় দেখুন।",
    proofBody:
      "ঐতিহাসিক ক্যান্ডলে নিয়ম পরীক্ষা করুন, প্রবেশ ও প্রস্থান দেখুন, তারপর মূল ফল সংরক্ষণ করে তুলনার জন্য একটি শর্ত বদলান।",
    planTitle: "প্ল্যানের মূল্য",
    planBody:
      "পেইড প্ল্যানে দীর্ঘ সময়ের পরীক্ষা, বেশি সংরক্ষিত ইতিহাস ও বেশি পেপার সিগন্যাল বট পাওয়া যায়।",
    riskTitle: "মূলধন হারাতে পারেন",
    riskBody:
      "ক্রিপ্টো ও আর্থিক সম্পদ ট্রেডিং উচ্চ ঝুঁকিপূর্ণ। আপনি আংশিক বা সম্পূর্ণ মূলধন হারাতে পারেন।",
    learnLabel: "শেখার কেন্দ্র পড়ুন",
    pricingLabel: "মূল্য",
  },
  id: {
    title: "Backtest - Penguji Strategi Trading",
    description:
      "Uji aturan pada candle historis, periksa masuk dan keluar, lalu simpan hasil awal dan ubah satu kondisi untuk dibandingkan.",
    noscriptTitle: "Backtest - Penguji Strategi Trading",
    noscriptBody:
      "Uji aturan pada candle historis, periksa masuk dan keluar, lalu simpan hasil awal dan ubah satu kondisi untuk dibandingkan.",
    proofTitle: "Lihat grafik, transaksi, dan risiko di satu tempat.",
    proofBody:
      "Uji aturan pada candle historis, periksa masuk dan keluar, lalu simpan hasil awal dan ubah satu kondisi untuk dibandingkan.",
    planTitle: "Nilai paket",
    planBody:
      "Paket berbayar menyediakan periode uji lebih panjang, lebih banyak riwayat tersimpan, dan bot sinyal simulasi.",
    riskTitle: "Modal bisa hilang",
    riskBody:
      "Trading crypto dan aset finansial berisiko tinggi. Anda bisa kehilangan sebagian atau seluruh modal.",
    learnLabel: "Baca pusat belajar",
    pricingLabel: "Harga",
  },
  fil: {
    title: "Backtest - Trading Strategy Tester",
    description:
      "Subukan ang tuntunin sa mga dating candle, suriin ang pagpasok at paglabas, saka i-save ang unang resulta at baguhin ang isang kondisyon para ihambing.",
    noscriptTitle: "Backtest - Trading Strategy Tester",
    noscriptBody:
      "Subukan ang tuntunin sa mga dating candle, suriin ang pagpasok at paglabas, saka i-save ang unang resulta at baguhin ang isang kondisyon para ihambing.",
    proofTitle: "Tingnan ang chart, mga trade, at panganib sa isang lugar.",
    proofBody:
      "Subukan ang tuntunin sa mga dating candle, suriin ang pagpasok at paglabas, saka i-save ang unang resulta at baguhin ang isang kondisyon para ihambing.",
    planTitle: "Halaga ng plan",
    planBody:
      "May mas mahabang panahon ng pagsusuri, mas maraming naka-save na kasaysayan, at paper signal bot ang mga bayad na plan.",
    riskTitle: "Puwedeng mawala ang capital",
    riskBody:
      "Mataas ang risk ng crypto at financial asset trading. Puwede kang mawalan ng bahagi o buong capital.",
    learnLabel: "Basahin ang learning center",
    pricingLabel: "Presyo",
  },
  "es-419": {
    title: "Backtest - Probador de estrategias de trading",
    description:
      "Prueba una regla con velas históricas, revisa entradas y salidas, guarda el resultado inicial y cambia una condición para comparar.",
    noscriptTitle: "Backtest - Probador de estrategias de trading",
    noscriptBody:
      "Prueba una regla con velas históricas, revisa entradas y salidas, guarda el resultado inicial y cambia una condición para comparar.",
    proofTitle: "Consulta el gráfico, las operaciones y el riesgo en un solo lugar.",
    proofBody:
      "Prueba una regla con velas históricas, revisa entradas y salidas, guarda el resultado inicial y cambia una condición para comparar.",
    planTitle: "Valor del plan",
    planBody:
      "Los planes de pago ofrecen periodos de prueba más largos, más historial guardado y más bots de señales simuladas.",
    riskTitle: "Puedes perder capital",
    riskBody:
      "Operar crypto y activos financieros tiene alto riesgo. Puedes perder parte o todo tu capital.",
    learnLabel: "Leer centro de aprendizaje",
    pricingLabel: "Precios",
  },
  "pt-BR": {
    title: "Backtest - Testador de estratégias de trading",
    description:
      "Teste uma regra em candles históricos, confira entradas e saídas, salve o resultado inicial e altere uma condição para comparar.",
    noscriptTitle: "Backtest - Testador de estratégias de trading",
    noscriptBody:
      "Teste uma regra em candles históricos, confira entradas e saídas, salve o resultado inicial e altere uma condição para comparar.",
    proofTitle: "Veja o gráfico, as operações e o risco em um só lugar.",
    proofBody:
      "Teste uma regra em candles históricos, confira entradas e saídas, salve o resultado inicial e altere uma condição para comparar.",
    planTitle: "Valor do plano",
    planBody:
      "Os planos pagos oferecem períodos de teste mais longos, mais histórico salvo e mais bots de sinais simulados.",
    riskTitle: "Você pode perder capital",
    riskBody:
      "Trading de cripto e ativos financeiros tem alto risco. Você pode perder parte ou todo o capital.",
    learnLabel: "Ler central de aprendizado",
    pricingLabel: "Preços",
  },
  ja: {
    title: "Backtest - トレード戦略テスター",
    description:
      "過去のローソク足でルールを検証し、エントリーと決済を確認。基準となる結果を保存して、条件を一つ変えて比較します。",
    noscriptTitle: "Backtest - トレード戦略テスター",
    noscriptBody:
      "過去のローソク足でルールを検証し、エントリーと決済を確認。基準となる結果を保存して、条件を一つ変えて比較します。",
    proofTitle: "チャート、取引、リスクをまとめて確認。",
    proofBody:
      "過去のローソク足でルールを検証し、エントリーと決済を確認。基準となる結果を保存して、条件を一つ変えて比較します。",
    planTitle: "プランの価値",
    planBody:
      "有料プランでは検証期間、保存履歴、ペーパーシグナルボットの上限が増えます。",
    riskTitle: "資金を失う可能性があります",
    riskBody:
      "暗号資産や金融商品の取引には高いリスクがあり、資金の一部または全部を失う可能性があります。",
    learnLabel: "学習センターを読む",
    pricingLabel: "料金",
  },
  ko: {
    title: "Backtest - 트레이딩 전략 테스터",
    description:
      "과거 캔들로 규칙을 테스트하고 진입과 청산을 확인하세요. 기준 결과를 저장한 뒤 조건 하나를 바꿔 비교하세요.",
    noscriptTitle: "Backtest - 트레이딩 전략 테스터",
    noscriptBody:
      "과거 캔들로 규칙을 테스트하고 진입과 청산을 확인하세요. 기준 결과를 저장한 뒤 조건 하나를 바꿔 비교하세요.",
    proofTitle: "차트, 거래, 위험을 한곳에서 확인하세요.",
    proofBody:
      "과거 캔들로 규칙을 테스트하고 진입과 청산을 확인하세요. 기준 결과를 저장한 뒤 조건 하나를 바꿔 비교하세요.",
    planTitle: "플랜 가치",
    planBody:
      "유료 플랜은 더 긴 테스트 기간, 더 많은 저장 기록과 모의 신호 봇을 제공합니다.",
    riskTitle: "자본 손실 가능성",
    riskBody:
      "암호화폐와 금융자산 거래는 고위험이며 자본의 일부 또는 전부를 잃을 수 있습니다.",
    learnLabel: "학습 센터 읽기",
    pricingLabel: "요금",
  },
  ru: {
    title: "Backtest - Тестер торговых стратегий",
    description:
      "Проверьте правило на исторических свечах, изучите входы и выходы, сохраните исходный результат и измените одно условие для сравнения.",
    noscriptTitle: "Backtest - Тестер торговых стратегий",
    noscriptBody:
      "Проверьте правило на исторических свечах, изучите входы и выходы, сохраните исходный результат и измените одно условие для сравнения.",
    proofTitle: "График, сделки и риск в одном месте.",
    proofBody:
      "Проверьте правило на исторических свечах, изучите входы и выходы, сохраните исходный результат и измените одно условие для сравнения.",
    planTitle: "Ценность плана",
    planBody:
      "Платные планы дают более длинные периоды тестирования, больше сохранённой истории и ботов учебных сигналов.",
    riskTitle: "Вы можете потерять капитал",
    riskBody:
      "Торговля крипто и финансовыми активами связана с высоким риском. Вы можете потерять часть или весь капитал.",
    learnLabel: "Читать учебный центр",
    pricingLabel: "Цены",
  },
  tr: {
    title: "Backtest - Trading Strateji Test Aracı",
    description:
      "Kuralı geçmiş mumlarda test edin, giriş ve çıkışları inceleyin, ilk sonucu kaydedip karşılaştırmak için tek bir koşulu değiştirin.",
    noscriptTitle: "Backtest - Trading Strateji Test Aracı",
    noscriptBody:
      "Kuralı geçmiş mumlarda test edin, giriş ve çıkışları inceleyin, ilk sonucu kaydedip karşılaştırmak için tek bir koşulu değiştirin.",
    proofTitle: "Grafik, işlemler ve riski tek yerde görün.",
    proofBody:
      "Kuralı geçmiş mumlarda test edin, giriş ve çıkışları inceleyin, ilk sonucu kaydedip karşılaştırmak için tek bir koşulu değiştirin.",
    planTitle: "Plan değeri",
    planBody:
      "Ücretli planlar daha uzun test aralıkları, daha fazla kayıtlı geçmiş ve simülasyon sinyal botu sunar.",
    riskTitle: "Sermaye kaybedebilirsiniz",
    riskBody:
      "Crypto ve finansal varlık trading'i yüksek risklidir. Sermayenizin bir kısmını veya tamamını kaybedebilirsiniz.",
    learnLabel: "Öğrenme merkezini oku",
    pricingLabel: "Fiyatlar",
  },
  uk: {
    title: "Backtest - Тестер торгових стратегій",
    description:
      "Перевірте правило на історичних свічках, перегляньте входи й виходи, збережіть початковий результат і змініть одну умову для порівняння.",
    noscriptTitle: "Backtest - Тестер торгових стратегій",
    noscriptBody:
      "Перевірте правило на історичних свічках, перегляньте входи й виходи, збережіть початковий результат і змініть одну умову для порівняння.",
    proofTitle: "Графік, угоди та ризик в одному місці.",
    proofBody:
      "Перевірте правило на історичних свічках, перегляньте входи й виходи, збережіть початковий результат і змініть одну умову для порівняння.",
    planTitle: "Цінність плану",
    planBody:
      "Платні плани дають довші періоди тестування, більше збереженої історії та ботів навчальних сигналів.",
    riskTitle: "Ви можете втратити капітал",
    riskBody:
      "Торгівля crypto та фінансовими активами має високий ризик. Ви можете втратити частину або весь капітал.",
    learnLabel: "Читати навчальний центр",
    pricingLabel: "Ціни",
  },
};
